import AuthCallbackContainer from '../containers/AuthCallback/AuthCallback.container'
import NotFoundPage from './NotFound'

/**
 * The AuthCallback' page.
 */
const AuthCallback = () => <AuthCallbackContainer fallback={() => <NotFoundPage />} />

export default AuthCallback
